<template>
  <div>
    <header-applis titre="Engager le financement" sous-titre="Vous êtes agent public (fonctionnaires et contractuels)" index-progression-courante="4"/>
    <div class="wrapper__content">
      <ul>
        <li>
          <p>Si vous ne l’avez pas encore fait :</p>
          <ul>
            <li>Activez votre compte personnel de formation et consultez de combien il est crédité: <a href="https://www.moncompteformation.gouv.fr/espace-prive/" target="_blank">www.moncompteformation.gouv.fr/espace-prive/</a>
            </li>
            <li>Agent de la Fonction Publique d’État, Fonction Publique Territoriale, Fonction Publique Hospitalière : renseignez-vous ensuite auprès de votre référent formation ou
              de votre référent en ressources humaines
            </li>
            <li>Vous pouvez également consulter les dispositifs mobilisables : <a href="https://www.service-public.fr/particuliers/vosdroits/N186" target="_blank">https://www.service-public.fr/particuliers/vosdroits/N186</a>
            </li>
            <li>cependant, si vous envisagez un contrat en alternance (apprentissage, professionnalisation) et que le diplôme permet cette possibilité, vous pourrez joindre directement le service de formation indiqué</li>
          </ul>
        </li>
      </ul>
    </div>
    <footer-applis ecran-precedent="choixstatutfinancement" ecran-suivant="fin" label-suivant="Terminer"/>
  </div>
</template>

<script>
import HeaderApplis from '../../components/HeaderApplis';
import FooterApplis from '../../components/FooterApplis';

export default {
  name: 'agentpublicfinancement',
  components: {
    FooterApplis,
    HeaderApplis
  }
}
</script>
